import {
  TextField,
  InputAdornment,
  IconButton,
  OutlinedTextFieldProps,
} from "@mui/material";
import React from "react";
import { BiSearch } from "react-icons/bi";

interface Props extends OutlinedTextFieldProps {
  handleBtnSearch: () => void;
  placeholder?: string;
  onKeyDown?: (event: any) => void;
}

const InputRanking: React.FC<Props> = ({
  handleBtnSearch,
  placeholder,
  onKeyDown,
  ...rest
}) => {
  return (
    <TextField
      label=""
      placeholder={placeholder || "Buscar Pessoas"}
      size="small"
      fullWidth
      onKeyDown={onKeyDown}
      InputProps={{
        startAdornment: (
          <InputAdornment position="start">
            <IconButton
              onClick={() => handleBtnSearch()}
              style={{
                backgroundColor: "transparent",
                margin: 0,
                padding: 0,
                height: 36,
              }}
            >
              <BiSearch color="black" size={22} />
            </IconButton>
          </InputAdornment>
        ),
        sx: {
          height: "36px",
          paddingRight: 0,
          borderRadius: 2,
          borderColor: "#ECECEC",
          borderWidth: 1.5,
        },
      }}
      {...rest}
    />
  );
};

export default InputRanking;
